import { zCustom } from '@nucleus/lib-shape';
import { yupKeyStringSchema, zKey } from '@nucleus/ncu-key-prefix';
import { ISO8601Schema } from '@nucleus/src-platform/data';
import * as yup from 'yup';
import { z } from 'zod';
import { PublishableEngineSchemaDeprecated } from './PublishableEngine';

export type PublishableEntityBase = z.infer<typeof PublishableEntityBaseSchema>;

export const PublishableEntityBaseSchema = z.object({
  id: zKey.prefixedKey(),
  engineId: zKey.prefixedKey(),
  createdAt: zCustom.iso(),
  createdBy: z.string().trim(),
  updatedAt: zCustom.iso(),
  updatedBy: z.string().trim(),
});

/**
 * @deprecated this schema is deprecated and will be removed in the future
 */
export const PublishableEntityBaseSchemaDeprecated: yup.SchemaOf<PublishableEntityBase> = yup.object({
  id: yupKeyStringSchema.required(),
  engineId: PublishableEngineSchemaDeprecated.fields.id.required(),
  createdAt: ISO8601Schema.required(),
  createdBy: yup.string().required(),
  updatedAt: ISO8601Schema.required(),
  updatedBy: yup.string().required(),
});
